import React from 'react';
import { compose, withHandlers, withState } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Visibility from '@material-ui/icons/Visibility';
import FormHelperText from '@material-ui/core/FormHelperText';
import Typography from '@material-ui/core/Typography';

import { MDBContainer, MDBRow, MDBCol, MDBCard, MDBCardBody, MDBInput, MDBBtn, MDBIcon, MDBModalFooter } from 'mdbreact';



import { commonStyles } from '../../styles/styles';

const renderPassword = ({
  classes,
  meta,
  registrationForm,
  input,
  id,
  showPassword,
  label,
  handleClickShowPassword,
}) => {
  const conditionError = meta.error && meta.touched;
  return (
    <FormControl
      className={`${classes.formField} ${registrationForm ? classes.regField : false}`}
      aria-describedby="name-error-text"
      error={conditionError}
      style={{width:'100%'}}
    >
    
      <MDBInput
        {...input}
        aria-describedby="name-error-text"
        error={conditionError}
        id={id}
        label={label}
        disableUnderline
        type={showPassword ? 'text' : 'password'}
       
        style={{width:'100%'}}
      />
      <div style={{position:'absolute', top:36, right:0,color: '#6d767e'}} onClick={()=> handleClickShowPassword()}>
  {showPassword ? <MDBIcon  icon='eye'/> : <MDBIcon icon='eye-slash' /> }
      </div>
      
      {conditionError && (
        <FormHelperText id="name-error-password" className={styles.errorBottomText}>
          {meta.error}
        </FormHelperText>
      )}
    </FormControl>
  );
};

renderPassword.propTypes = {
  classes: PropTypes.instanceOf(Object),
  meta: PropTypes.instanceOf(Object),
  input: PropTypes.instanceOf(Object),
  registrationForm: PropTypes.bool,
  label: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  showPassword: PropTypes.bool,
  handleClickShowPassword: PropTypes.func,
};

const styles = () => ({
  ...commonStyles,
});

export default compose(
  withState('showPassword', 'handleShowPassword', false),
  withHandlers({
    handleClickShowPassword: props => event => {
  
      return props.handleShowPassword(!props.showPassword);
    },
  }),
  withStyles(styles),
)(renderPassword);
